var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPieChart = function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7147 12.0001C22.7147 17.9174 17.9178 22.7143 12.0004 22.7143C6.08308 22.7143 1.28613 17.9174 1.28613 12.0001C1.28613 6.08272 6.08308 1.28577 12.0004 1.28577M22.7147 12.0001C22.7147 6.08272 17.9178 1.28577 12.0004 1.28577M22.7147 12.0001C22.7147 14.0861 22.1185 16.0329 21.0873 17.6793L13.6118 13.0072C12.6094 12.3807 12.0004 11.2819 12.0004 10.0998V1.28577",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgPieChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI3MV8xNTg1KSI+CjxwYXRoIGQ9Ik0yMi43MTQ3IDEyLjAwMDFDMjIuNzE0NyAxNy45MTc0IDE3LjkxNzggMjIuNzE0MyAxMi4wMDA0IDIyLjcxNDNDNi4wODMwOCAyMi43MTQzIDEuMjg2MTMgMTcuOTE3NCAxLjI4NjEzIDEyLjAwMDFDMS4yODYxMyA2LjA4MjcyIDYuMDgzMDggMS4yODU3NyAxMi4wMDA0IDEuMjg1NzdNMjIuNzE0NyAxMi4wMDAxQzIyLjcxNDcgNi4wODI3MiAxNy45MTc4IDEuMjg1NzcgMTIuMDAwNCAxLjI4NTc3TTIyLjcxNDcgMTIuMDAwMUMyMi43MTQ3IDE0LjA4NjEgMjIuMTE4NSAxNi4wMzI5IDIxLjA4NzMgMTcuNjc5M0wxMy42MTE4IDEzLjAwNzJDMTIuNjA5NCAxMi4zODA3IDEyLjAwMDQgMTEuMjgxOSAxMi4wMDA0IDEwLjA5OThWMS4yODU3NyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS43MTQyOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNzFfMTU4NSI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";